<template>
  <component :is="homeView" />
</template>

<script>
export default {
  layout({ $config }) {
    return $config.CUSTOM_LAYOUT ? "bycustomer/" + $config.CUSTOMER : "default";
  },
  data({ $config }) {
    return {
      homeView: () =>
        import(
          /* webpackChunkName: "home" */ "@/components/bycustomer/home/" +
            $config.CUSTOMER +
            ".vue"
        ), // interpolation evades warnings
    };
  },
};
</script>
